import { h } from "preact";
import { RoutableProps } from "preact-router";
import { resolvePath } from "../../api";
import { applicationState, route } from "../../App";
import { useForceUpdate } from "../../hooks";
import  "./styles.scss";

const products = [
    {
        name: "Luna EMG",
        route: "/luna-emg",
        description: "Robot rehabilitacyjno-diagnostyczny umożliwiający ćwiczenia w obrębie kończyn górnych, dolnych oraz tułowia do rehabilitacji",
        image: resolvePath("images/parts/LunaEMG/Luna EMG.jpg"),
        bar: "linear-gradient(to right, #1897d8, #9a42ab);"
    },
    {
        name: "Stella BIO",
        route: "/stella-bio",
        description: "Mobilny elektromiograf z elektrostymulacją wyzwalaną do rehabilitacji. Urządzenie do biofeedbacku elektromiograficznego i elektrostymulacji dna miednicy",
        image: resolvePath("images/parts/StellaBIO/StellaBIO.jpg"),
        bar: "linear-gradient(to right, #1897d8, #3de0cb);"
    },
    {
        name: "Mezos SIT",
        route: "/mezos-sit",
        description: "Mezos SIT jest przeznaczony do użytku jako krzesło lub leżanka w celu zapewnienia pozycjonowania i wsparcia pacjentów podczas badań ogólnych lub zabiegów leczniczych prowadzonych przez lekarzy.",
        image: resolvePath("images/parts/MezosSIT/MezosSIT.jpg"),
        bar: "linear-gradient(to right, #a7a9ac, #f1f1f2);"
    },
    {
        name: "Sidra LEG",
        route: "/sidra-leg",
        description: "Mobilny robot rehabilitacyjny dolnych partii ciała.",
        image: resolvePath("images/parts/SidraLEG/SidraLEG.jpg"),
        bar: "linear-gradient(to right, #a7a9ac, #f1f1f2);"
    },
    {
        name: "Meissa OT",
        route: "/meissa-ot",
        description: "Mobilny robot rehabilitacyjny dłoni oraz przedramienia.",
        image: resolvePath("images/parts/MeissaOT/MeissaOT.jpg"),
        bar: "linear-gradient(to right, #1897d8, #f9c2ce);"
    }
]

export function Products(props: RoutableProps) {
    const state = applicationState;
    const forceUpdate = useForceUpdate();

    return <div class="products-page">
        <div class="product-list">
            {products.map(v => <div style="margin: 10px; width: 600px; height: 200px;" class="paper product" onClick={() => route(v.route)}>
                <div style={{
                    width: "200px",
                    height: "200px",
                    flexShrink: "0",
                    backgroundImage: `url("${v.image}")`,
                    backgroundPosition: "center",
                    backgroundSize: "contain"
                }}>
                </div>
                <div class="h-full flex flex-col" style="flex: 1 1">
                    <div style={`height: 20px; background: ${v.bar}`}></div>
                    <div style="padding: 0px 10px; display: flex; justify-content: center; align-items: center;">
                        <div style="flex: 1 1 0; padding: 0px 10px; font-size: 32px; font-family: 'Exo'">
                            <div>{v.name}</div>
                        </div>
                    </div>
                    <div style="padding: 10px 15px;" class="grow">
                        {v.description}
                    </div>
                    <div class="pb-2 pl-1" style="margin-left: 10px; color: var(--palette-accent); text-transform: uppercase; font-size: 13px; font-weight: 500">Naciśnij aby wybrać</div>
                </div>
            </div>)}
            {/* <div class="product-button button primary" onClick={() => route("/luna-emg")}>Luna EMG</div>
            <div class="product-button button primary" onClick={() => route("/stella-bio")}>Stella BIO</div> */}
        </div>
    </div>;
}
